import React from 'react'
import PropTypes from 'prop-types'

function KidsExclude({ styling }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1200 1200"
      className={styling}
    >
      <path d="M600 30C285.6 30 30 285.6 30 600s255.6 570 570 570 570-255.6 570-570S914.4 30 600 30zm368.4 874.8L826.8 762c-3.602 4.8-7.2 9.602-10.801 14.398-18 20.398-46.801 31.199-73.199 30l162 162c-86.398 70.801-194.4 110.4-304.8 110.4-264 .004-478.8-214.8-478.8-478.8 0-110.4 39.602-218.4 110.4-304.8l135.6 135.6c16.801-10.801 36-14.398 56.398-13.199 15.602 1.2 30 7.2 43.199 16.801 3.602-7.2 7.2-14.398 12-20.398l-183.6-182.4c86.398-72 194.4-110.4 304.8-110.4 264-.004 478.8 214.8 478.8 478.8 0 110.4-38.402 218.4-110.4 304.8z" />
      <path d="M738 241.2c-44.398 0-79.199 43.199-79.199 96 0 45.602 26.398 82.801 61.199 93.602-3.602 33.602-2.398 66 13.199 115.2 14.398 45.602 9.602 81.602 3.602 117.6L678 610.801c-15.602-14.398-34.801-21.602-56.398-21.602H556.8c-24 0-48-10.801-62.398-30L436.8 488.398c-10.801-13.199-30-15.602-44.398-4.8-13.2 10.8-15.602 30-4.801 44.397l57.602 70.801c15.602 18 34.8 32.398 55.199 42l-.004 271.2c0 16.801 14.398 31.2 31.199 31.2 16.8 0 31.199-14.399 31.199-31.2l.004-123.6c0-4.8 3.601-8.398 8.398-8.398H600c4.801 0 8.399 3.601 8.399 8.398v123.6c0 16.801 14.398 31.2 31.199 31.2 16.8 0 31.199-14.399 31.199-31.2l.004-223.2 56.398 50.398c6 6 13.199 8.399 20.398 8.399 8.398 0 16.8-3.602 22.8-10.801 12-13.2 10.802-32.398-2.398-44.398l-4.8-4.801c7.199-34.801 18-90-1.2-151.2-15.602-48-14.398-75.602-10.8-104.4 37.198-7.2 66-46.801 66-94.801 0-52.801-34.802-96-79.2-96z" />
      <path d="M662.4 493.2c0 41.754-33.848 75.602-75.598 75.602-41.754 0-75.602-33.848-75.602-75.602 0-41.75 33.848-75.598 75.602-75.598 41.75 0 75.598 33.848 75.598 75.598z" />
    </svg>
  )
}
// PROPTYPES
const { string } = PropTypes
KidsExclude.propTypes = {
  styling: string,
}

export default KidsExclude
